<div>
    <ng-container *ngIf="data.length > 0; else empty">
        <div echarts [options]="options" (chartInit)="onChartInit($event)" style="margin-left: -40px;"></div>
    </ng-container>

    <ng-template #empty>
        <nz-empty nzNotFoundImage="simple"></nz-empty>
    </ng-template>
</div>

